module.exports = __webpack_public_path__ + "static/media/Naomi.ff0fda02.jpg";